<img *ngIf="contaId" class="logo" src="/assets/img/logo-colorida.svg">

<div [hidden]="loaded || error" class="container-loading">
  <div class="btn btn-registrar loading"></div>
</div>

<div [hidden]="!loaded || error" id="page-content" class="pagamentos">
    <div class="col-lg-10 col-lg-offset-1 col-sm-12">
      <section class="error-section circled border-red block-if-big-screen hide-if-mobile" *ngIf="faturamento && faturamento.Problemas && faturamento.Problemas.length">
        <div class="error-container">
<!--          <div class="error-warning">-->
<!--            <img src="assets/img/aviso-alerta.svg" alt="Fatura em aberto!">-->
<!--          </div>-->
          <div class="fill">
            <div class="col-12 error-info" style="padding-top: 3px;" *ngFor="let problema of faturamento.Problemas">
              <div class="row problema-msg-row">
                <span class="inner-row">
                  <span [innerHTML]="problema.Mensagem"></span>
                  <strong class="red">{{ problema.Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</strong>
                </span>
                <div class="btn-container">
                  <div>
                    <button class="btn btn-danger button-resolver" (click)="resolverProblema(problema);">Resolver</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="row">
        <div class="col-lg-10 col-lg-offset-1 col-sm-12">
          <div class="flex container-proximo-pagamento">
            <div class="card-flex">
              <div class="totais transacoes">
                <h4>Transações</h4>
                <div class="destaque-totais">
                  <h5><span id="qtd-transacoes"></span></h5>
                </div>
              </div>
            </div>
            <div class="card-flex">
              <div class="ciclo">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 112 112">
                  <defs>
                    <linearGradient id="a" y1="56" x2="112" y2="56" gradientUnits="userSpaceOnUse">
                      <stop offset="0" stop-color="#4379ff" />
                      <stop offset="0.32" stop-color="#2f9dff" />
                      <stop offset="1" stop-color="#00f6ff" />
                    </linearGradient>
                  </defs>
                  <title>ciclo</title>
                  <circle cx="56" cy="56" r="55" fill="none" stroke="#e6e6e6" stroke-miterlimit="10" />
                  <circle id="cicle" cx="56" cy="56" r="55" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" opacity="0.9" stroke="url(#a)" transform="rotate(-90 56 56)" />
                </svg>
                <div class="content">
                  <h4 class="mar-no">Ciclo</h4>
                  <div class="periodo">
                    <span>{{ciclo.inicio}}</span> a</div>
                  <div class="periodo">
                    <span>{{ciclo.fim}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="card-flex" *ngIf="faturamento">
                <div class="info-column circled">
                  <h3 *ngIf="!isProvisao()">Próximo Pagamento</h3>
                  <h3 *ngIf="isProvisao()">Provisão atual</h3>
                  <div class="row">
                    <div class="col-12">
                      <div class="weak-p" *ngIf="isProvisao()">Valor estimado</div>
                      <div class="weak-p" *ngIf="!isProvisao()">Valor do próximo vencimento</div>
                      <div class="strong-p" *ngIf="valorProximoPagamento"><strong >{{ valorProximoPagamento }}</strong></div>

                      <div class="strong-p mt-10" [innerHTML]="obterDescricao()"></div>

                      <div>
                        <div class="mt-10 strong-p small-p" *ngIf="isCartao()">Pagamento programado para {{ dataProximoPagamento }}</div>
                        <div class="mt-10 strong-p small-p" *ngIf="!isCartao()">Próximo vencimento em {{ dataProximoPagamento }}</div>
                      </div>
                      <hr class="strong-p">
                      <div class="strong-p large-p">
                        <strong>Forma de pagamento</strong>
                      </div>

                      <div class="cartao-row mb-10" *ngIf="cartaoCadastrado">
                        <div class="cartao-row-bandeira">
                          <div [class]="'bandeira-cartao ' + obterClasseBandeiraCartao(cartaoCadastrado.Bandeira)"></div>
                        </div>
                        <div class="Cartao-row-info mt-10">
                          <div class="weak-p large-p compressed-vertical-p">
                            <strong>{{ cartaoCadastrado.Bandeira }}</strong>&nbsp;&nbsp;<small>****</small>&nbsp;&nbsp;<strong>{{ cartaoCadastrado.Numero }}</strong>
                          </div>
                          <div class="weak-p small-p compressed-vertical-p">Validade: {{ cartaoCadastrado.DataValidade }}
                          </div>
                        </div>
                      </div>

                      <div class="cartao-row mb-10" *ngIf="!cartaoCadastrado" class="mt-10">Não há cartão cadastrado para pagamento automático.</div>
                      <a (click)="adicionarCartao()" *ngIf="!cartaoCadastrado" class="btn-acao-pagamento mt-10">Adicionar</a>
                      <a (click)="alterarCartao()" *ngIf="cartaoCadastrado" class="btn-acao-pagamento mt-10">Alterar</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</div>

<app-modal-detail [showModal]="showModalError" (eventClose)="eventClose()">
  <h4 style="text-align: center;">{{ errorMessage }}</h4>
</app-modal-detail>
